import React from 'react';
import { Skeleton, Card, CardContent, Box } from '@mui/material';

const CardPosteSkeleton = () => {
  return (
    <Card sx={{ 
      maxWidth: '100%', 
      mb: 2, 
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      borderRadius: '10px'
    }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Skeleton variant="text" width="40%" height={40} />
          <Skeleton variant="text" width="20%" height={40} />
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Skeleton variant="rectangular" width={100} height={30} />
          <Skeleton variant="rectangular" width={100} height={30} />
          <Skeleton variant="rectangular" width={100} height={30} />
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          {[...Array(6)].map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={120} height={25} />
          ))}
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {[...Array(4)].map((_, index) => (
            <Skeleton key={index} variant="rectangular" width={150} height={25} />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardPosteSkeleton; 